var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentreporticon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 2290"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 187",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#BFC0DF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chat"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_398_2129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_398_2129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chat_2",
    d: "M14.25 21.75H21.75V20.25H14.25V21.75ZM14.25 18.75H25.75V17.25H14.25V18.75ZM14.25 15.75H25.75V14.25H14.25V15.75ZM10.5 29.0384V12.3077C10.5 11.8026 10.675 11.375 11.025 11.025C11.375 10.675 11.8026 10.5 12.3077 10.5H27.6923C28.1974 10.5 28.625 10.675 28.975 11.025C29.325 11.375 29.5 11.8026 29.5 12.3077V23.6923C29.5 24.1974 29.325 24.625 28.975 24.975C28.625 25.325 28.1974 25.5 27.6923 25.5H14.0385L10.5 29.0384ZM13.4 24H27.6923C27.7692 24 27.8397 23.9679 27.9038 23.9038C27.9679 23.8397 28 23.7692 28 23.6923V12.3077C28 12.2308 27.9679 12.1602 27.9038 12.0961C27.8397 12.032 27.7692 12 27.6923 12H12.3077C12.2308 12 12.1602 12.032 12.0961 12.0961C12.032 12.1602 12 12.2308 12 12.3077V25.3846L13.4 24Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentreporticon);
export default __webpack_public_path__ + "static/media/commentreporticon.18c7dcb69738fe0c0910aecc653b0429.svg";
export { ForwardRef as ReactComponent };